import { Col } from "antd";
import styled from "styled-components";

const Data = styled(Col)`
  color: #fff;
  padding-right: 24px;
  text-align: right;
  text-transform: uppercase;
`;

export { Data };
